import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../../axios/centralApiAxios";
import { UPDATE_TENANT } from '../../actions';

import {
  updateTenantSuccess,
  updateTenantError
} from './actions';

const UPDATE_TENANT_ERROR = "Updating tenant fails.";

const updateTenantAsync = async (tenantToUpdate, id) => {
  let dataReturned;
  try {
    dataReturned = await centralApiAxios.put("tenants?id=" + id, tenantToUpdate);
    if (dataReturned.data) {
      return {
        successMessage: "Tenant update was successfull.",
        message: null,
      };
    }
    return { message: UPDATE_TENANT_ERROR };
  } catch (error) {
    return {
      message: UPDATE_TENANT_ERROR,
    };
  }
};

function* updateTenant({ payload }) {
  try {
    const resultReturned = yield call(updateTenantAsync, payload.tenantToUpdate, payload.id);
    if (!resultReturned.message) {
      yield put(updateTenantSuccess(resultReturned.collectionItem));
      window.location.reload();
    } else {
      yield put(updateTenantError(resultReturned.message));
    }
  } catch (errorExp) {
    yield put(updateTenantError(UPDATE_TENANT_ERROR));
  }
}

export function* watchUpdateTenant() {
  yield takeEvery(UPDATE_TENANT, updateTenant);
}


export default function* rootSaga() {
  yield all([
    fork(watchUpdateTenant)
  ]);
}
